import { environment } from './environments/environment';

const awsS3BucketUrl = environment.aws_s3_bucket_url;
const posAssestsPath = '/partner-app-images/';
const baseUrl = awsS3BucketUrl + posAssestsPath;

//  Lock Screens
export const LOCK_SCREEN_BASE_URL = baseUrl + 'lock-screen/';
export const AUGUST_2026_LOCK_SCREEN_BASE_URL = 'https://d3m4xmtukhnp3c.cloudfront.net/partner-app-images/lock-screen/id-aug-2026/';
export const RAMADAN_LOCK_SCREEN_BASE_URL = 'https://d3pcazt4taz3aq.cloudfront.net/partner-app-images/lock-screen/id/';
export const PRO = baseUrl + 'lock-screen/pro.png';
export const LITE = baseUrl + 'lock-screen/lite.png';
export const SUCCESS_TICK = baseUrl + 'lock-screen/success_tick.svg';
export const FAILED_CROSS = baseUrl + 'lock-screen/failed_cross.svg';

// Cash Register
export const CASH_REGISTER_URL = baseUrl + 'cash_register/';
export const CASH_IN = baseUrl + 'cash_register/cash_in.svg';
export const CASH_OUT = baseUrl + 'cash_register/cash_out.svg';
export const CASH_COUNTER = baseUrl + 'cash_register/cash-counter.svg';
export const DRAWER_KICK = baseUrl + 'cash_register/drawer_kick.svg';

// CMM Menu
export const REARRANGE = baseUrl + 'cmm_menu/reaarange.svg';
export const SALAD1 = baseUrl + 'cmm_menu/salad1.svg';

// CMM
export const CLOSE_CAT_SUBCAT = baseUrl + 'cmm/close-cat-subcat.svg';
export const CLOSE_CMM = baseUrl + 'cmm/close.svg';
export const CREATE_MENU = baseUrl + 'cmm/create-menu.svg';
export const DELETE_CAT_SUBCAT = baseUrl + 'cmm/delete-cat-subcat.svg';
export const DISH_LIBRARY = baseUrl + 'cmm/dish-library.svg';
export const EDIT_CAT_SUBCAT = baseUrl + 'cmm/edit-cat-subcat.svg';
export const SAVE_CAT_SUBCAT = baseUrl + 'cmm/save-cat-subcat.svg';
export const BULK_UPLOAD_FILE = baseUrl + 'cmm/bulk-upload.svg';
export const FILE_ICON = baseUrl + 'cmm/file-icon.svg';
export const BACK_ICON = baseUrl + 'cmm/back-icon.svg';
export const BULK_UPLOAD_LOADER = baseUrl + 'cmm/bulk-upload-animation.gif';
export const COMBO_FOOD = baseUrl + 'cmm/combo-food-icon.svg';
export const MULTIPLE_PRICE = baseUrl + 'cmm/multiple-price-icon.svg';
export const OPEN_ITEM = baseUrl + 'cmm/open-items-icon.svg';
export const CMM_ERROR_ICON = baseUrl + 'cmm/error-icon.svg';

// Common Image
export const NO_DROPDOWN_DATA = baseUrl + 'common/no-dropdown-data.svg';
export const REVERT_ICON = baseUrl + 'common/revert-order.svg';
export const MINUS_ICON = baseUrl + 'common/- Icon.svg';
export const ARROW_DOWN = baseUrl + 'common/arrow_down.svg';
export const ASPECT_RATIO_MAT = baseUrl + 'common/aspect-ratio-material.png';
export const BACK = baseUrl + 'common/back.svg';
export const BARTENDER = baseUrl + 'common/bartender.png';
export const BIN = baseUrl + 'common/bin (1).svg';
export const BUSINESS = baseUrl + 'common/business.svg';
export const CALENDAR_PNG = baseUrl + 'common/calendar.png';
export const CALENDAR_SVG = baseUrl + 'common/calendar.svg';
export const CANCEL = baseUrl + 'common/cancel.png';
export const CASH_TALLY = baseUrl + 'common/cash-tally.svg';
export const CASH = baseUrl + 'common/cash.svg';
export const CHEF = baseUrl + 'common/chef.png';
export const CHEVRON_RIGHT = baseUrl + 'common/chevron-right.png';
export const CROSS_2X = baseUrl + 'common/Cross 2X.png';
export const CROSS = baseUrl + 'common/cross.svg';
export const DELETE = baseUrl + 'common/delete.png';
export const DISCOUNT = baseUrl + 'common/discount.svg';
export const EDIT_3 = baseUrl + 'common/edit-3.svg';
export const EDIT_PNG = baseUrl + 'common/edit.png';
export const EDIT_SVG = baseUrl + 'common/edit.svg';
export const EMPTY_CART = baseUrl + 'common/empty_cart.svg';
export const EMPTY_STAFF = baseUrl + 'common/empty_staff.svg';
export const EMPTY_RESULT = baseUrl + 'common/emptyresult.svg';
export const ERROR = baseUrl + 'common/error.svg';
export const FOOD = baseUrl + 'common/food.svg';
export const FORK_KNIFE = baseUrl + 'common/fork_knife.png';
export const GROUP_9578 = baseUrl + 'common/Group 9578.svg';
export const ICON_8_SEARCH = baseUrl + 'common/icons8-search.svg';
export const INGREDIENT_IN_STOCK_GREEN =
  baseUrl + 'common/ingredient-in-stock-green.svg';
export const INTERFACE = baseUrl + 'common/interface (4).svg';
export const LOADER = baseUrl + 'common/loader.svg';
export const LOGIN_SUCCESS = baseUrl + 'common/login-success.svg';
export const LOW_STOCK_YELLOW = baseUrl + 'common/low-stock-yellow.svg';
export const MENU_2 = baseUrl + 'common/menu (2).svg';
export const MENU = baseUrl + 'common/menu.svg';
export const MORE = baseUrl + 'common/more.png';
export const MULTIMDEIA_WHITE = baseUrl + 'common/multimedia-white.svg';
export const MULTIMEDIA = baseUrl + 'common/multimedia.svg';
export const NO_ORDER = baseUrl + 'common/no_order.svg';
export const NO_PERMISSION = baseUrl + 'common/no_permission.svg';
export const NO_ORDER_DETAILS = baseUrl + 'common/no-order-details.svg';
export const NO_RESULT = baseUrl + 'common/noresult.svg';
export const OUT_STOCK_RED = baseUrl + 'common/out_stock_red.svg';
export const OUTLET = baseUrl + 'common/outlet.svg';
export const PERSON_FEMALE = baseUrl + 'common/person-female.png';
export const PERSON_MALE = baseUrl + 'common/person-male.png';
export const PERSON_MATERIAL = baseUrl + 'common/person-material.png';
export const PLUS_3_1 = baseUrl + 'common/plus (3) (1).svg';
export const PLUS_3 = baseUrl + 'common/plus (3).svg';
export const REMOVE = baseUrl + 'common/remove.svg';
export const PLUS_ICON = baseUrl + 'common/plus-icon.svg';
export const REST_LOCATION = baseUrl + 'common/rest_location.svg';
export const RIDER = baseUrl + 'common/rider.svg';
export const RISE = baseUrl + 'common/rise.svg';
export const ROBOT_1 = baseUrl + 'common/robot1.svg';
export const ROBOT_2 = baseUrl + 'common/robot2.svg';
export const ROTATE = baseUrl + 'common/rotate.svg';
export const SAVE_1 = baseUrl + 'common/save (1).svg';
export const SERVER = baseUrl + 'common/server.png';
export const SOCIAL_MEDIA_1 = baseUrl + 'common/social-media (1).svg';
export const SORT = baseUrl + 'common/sort.svg';
export const TICK = baseUrl + 'common/tick.svg';
export const TOOLS_AND_UTENSILS = baseUrl + 'common/tools-and-utensils (2).svg';
export const TRANSFER = baseUrl + 'common/transfer.svg';
export const TRASH_2_3 = baseUrl + 'common/trash-2 (3).svg';
export const TRASH = baseUrl + 'common/trash.svg';
export const USER_LOCATION = baseUrl + 'common/user_location.svg';
export const USER_DEFAULT = baseUrl + 'common/user-default.png';
export const USER = baseUrl + 'common/user.png';
export const VEG_ICON = baseUrl + 'common/Veg icon.svg';
export const WAITER_NEW = baseUrl + 'common/waiter-new.svg';
export const WAITER = baseUrl + 'common/waiter.svg';
export const STAR_1 = baseUrl + 'common/rating/star (1).svg';
export const STAR_HALF_EMPTY = baseUrl + 'common/rating/star-half-empty.svg';
export const STAR = baseUrl + 'common/rating/star.svg';
export const BLUE_ARROW = baseUrl + 'common/blue_arrow.svg';
export const DELETE_ICON_LARGE = baseUrl + 'common/delete-icon-large.svg';
export const REMOVE_DISABLED = baseUrl + 'common/remove_disabled.svg';
export const MENU_ITEM_NOT_FOUND = baseUrl + 'common/menu_item_not_found.webp';
export const ALERT = baseUrl + 'common/alert.svg';
export const CONNECT = baseUrl + 'common/connect.svg';
export const CONNECT_GREEN = baseUrl + 'common/connect-green.svg';
export const MPOS_CROSS = baseUrl + 'common/mpos-cross.svg';
export const FILTER_ICON = baseUrl + 'common/filter-icon.svg';
export const EE_BOOST_PARTNERSHIP =
  baseUrl + 'common/boost-partnership-logo.svg';
export const DOWNLOAD_ICON_OUTLINE = baseUrl + 'common/download-icon.svg';
export const TRASH_ICON = baseUrl + 'common/delete-icon.svg';
export const PEN_ICON  = baseUrl + 'common/pen-icon.svg';
export const FAILED_RED_DROPDOWN =
  baseUrl + 'orders/payment-failed-dropdown.svg';
export const UNPAID_DROPDOWN = baseUrl + 'orders/unpaid-dropdown.svg';
export const PAID_DROPDOWN = baseUrl + 'orders/paid-icon-history.svg';
export const PARTIAL_PAID_DROPDOWN =
  baseUrl + 'orders/partially-paid-dropdown.svg';
export const CROSS_PAYMENT = baseUrl + 'orders/close-payment-history.svg';
export const RED_INFO_ICON = baseUrl + 'common/red_error.svg';
export const DYNAMIC_QR_MODAL = baseUrl + 'common/dynamic-qr-icon.svg';
export const EASYEAT_LOGO = baseUrl + 'common/easyeat-icon.svg';
export const FOODPANDA_LOGO = baseUrl + 'common/foodpanda-icon.svg';
// Current Status
export const FOODPANDA = baseUrl + 'current-status/foodpanda.svg';
export const GRAB = baseUrl + 'current-status/Grab.svg';
export const EASYEAT = baseUrl + 'current-status/EE.svg';

// Customer
export const CUSTOMER_URL = baseUrl + 'customer/';
export const CONTENT = baseUrl + 'customer/content.png';
export const CREATE_CAMPAIGN = baseUrl + 'customer/create-campaing.png';
export const CREATE = baseUrl + 'customer/create.svg';
export const CUSGRP = baseUrl + 'customer/cusgrp.png';
export const CUSTOM = baseUrl + 'customer/custom.png';
export const DISABLE_EMAIL = baseUrl + 'customer/disable-email.png';
export const DOWNLOAD_FILE = baseUrl + 'customer/download-file.png';
export const DOWNLOAD = baseUrl + 'customer/download.png';
export const EMAIL = baseUrl + 'customer/email.svg';
export const EMAIL_2 = baseUrl + 'customer/email2.png';
export const EXCEL_LOGO = baseUrl + 'customer/Excel Logo.png';
export const FILE_1 = baseUrl + 'customer/file1.png';
export const FILLED_UPLOAD = baseUrl + 'customer/filled-upload.png';
export const GROUP_30463 = baseUrl + 'customer/Group 30463.svg';
export const LIST = baseUrl + 'customer/list.png';
export const MARKETING_C = baseUrl + 'customer/marketing.png';
export const NOTIFICATION_PNG = baseUrl + 'customer/notification.png';
export const NOTIFICATION_SVG = baseUrl + 'customer/notification.svg';
export const SMS = baseUrl + 'customer/sms.png';
export const SOCIAL_MEDIA_PNG = baseUrl + 'customer/social-media.png';
export const SOCIAL_MEDIA_SVG = baseUrl + 'customer/social-media.svg';
export const TEMPLATE = baseUrl + 'customer/template.png';
export const TICK_PNG = baseUrl + 'customer/tick.png';
export const UPLOAD_IMG = baseUrl + 'customer/Upload image.svg';
export const UPLOAD_FILE = baseUrl + 'customer/upload-file.png';

// Dashboard
export const GROUP_10 = baseUrl + 'dashboard/Group 10.svg';
export const GROUP_10_1 = baseUrl + 'dashboard/Group 10 (1).svg';
export const GROUP_10_2 = baseUrl + 'dashboard/Group 10 (2).svg';
export const GROUP_10_3 = baseUrl + 'dashboard/Group 10(3).svg';

//   Grab Images
export const EASYEAT_GRAB = baseUrl + 'grab-images/easyeat.svg';
export const GOT_IT_GRAB = baseUrl + 'grab-images/gotIt.png';
export const GRAB_GRAB = baseUrl + 'grab-images/grab.svg';
export const GRAB_LARGE = baseUrl + 'grab-images/grablarge.png';
export const IACCEPT = baseUrl + 'grab-images/iaccept.png';
export const ICON_GRAB = baseUrl + 'grab-images/Icon.png';
export const TICK_GRAB = baseUrl + 'grab-images/tick.svg';
export const YEL_INFO = baseUrl + 'grab-images/yel_info.png';

// Id_Images
export const ID_IMAGES_URL = baseUrl + 'id_images/';
export const ID_CURRENCY_INDICATOR =
  baseUrl + 'id_images/hq/cmm/id_currency_indicator.jpg';
export const ID_BILLING = baseUrl + 'id_images/hq/common/id_billing.png';
export const ID_CURRENCY = baseUrl + 'id_images/hq/common/id_currency.jpg';
export const ID_LOYALTY_START =
  baseUrl + 'id_images/hq/loyalty/id_loyalty_start.jpg';
export const ID_CUSTOMER_GROUP_TEMPLATE =
  baseUrl + 'id_images/hq/marketing/id_customer_group_template.png';
export const ID_PAID = baseUrl + 'id_images/orders-dashboard/id_paid.jpg';
export const ID_PARTIALLY_PAID =
  baseUrl + 'id_images/orders-dashboard/id_partially_paid.jpg';
export const ID_UNPAID = baseUrl + 'id_images/orders-dashboard/id_unpaid.jpg';
export const ID_BXGDY = baseUrl + 'id_images/promotions/id_bxgdy.jpg';
export const ID_BXGY_DISCOUNT =
  baseUrl + 'id_images/promotions/id_bxgy_discount.jpg';
export const ID_FLAT_DISCOUNT =
  baseUrl + 'id_images/promotions/id_flat_discount.jpg';
export const ID_FREE_DELIVERY =
  baseUrl + 'id_images/promotions/id_free_delivery.jpg';
export const ID_ORDER_VALUE_DISCOUNT =
  baseUrl + 'id_images/promotions/id_order_value_discount.jpg';
export const ID_PERCENT_DISCOUNT_JPG =
  baseUrl + 'id_images/promotions/id_percent_discount.jpg';
export const ID_PERCENT_DISCOUNT_PNG =
  baseUrl + 'id_images/promotions/id_percent_discount.png';
export const ID_PRICE_CUT = baseUrl + 'id_images/promotions/id_price_cut.jpg';
export const PROMOTION_ID_URL = baseUrl + 'id_images/promotions/id_';

// Images
export const ADD_MENU = baseUrl + 'images/add-menu.svg';
export const ADDON_VARIANTS = baseUrl + 'images/addon-variants.svg';
export const AVAILABILITY = baseUrl + 'images/availability.svg';
export const BASIC_DETAILS = baseUrl + 'images/basic-details.svg';
export const BBQ = baseUrl + 'images/bbq.svg';
export const BILLING = baseUrl + 'images/billing.svg';
export const CANCEL_BLUE = baseUrl + 'images/cancel_blue.png';
export const CANCEL_RED = baseUrl + 'images/cancel_red.svg';
export const CLIPBOARD_2 = baseUrl + 'images/clipboard-2.svg';
export const CLOSE_ICON = baseUrl + 'images/close-icon.svg';
export const CLOSE = baseUrl + 'images/close.svg';
export const COMBO_ICON = baseUrl + 'images/combo-icon.svg';
export const COMBO_ITEMS = baseUrl + 'images/combo-items.svg';
export const DELETE_ICON_OUTLINE = baseUrl + 'images/delete-icon-outline.svg';
export const DELETE_ICON = baseUrl + 'images/delete-icon.svg';
export const DINNER = baseUrl + 'images/dinner.svg';
export const DOWN_ARROW_IMG = baseUrl + 'images/down-arrow.png';
export const EDIT = baseUrl + 'images/edit.svg';
export const EMAIL_SVG = baseUrl + 'images/email.svg';
export const ERROR_CIRCLE = baseUrl + 'images/error-circle.png';
export const FOOD_PNG = baseUrl + 'images/food.png';
export const FOUR_SQUARES = baseUrl + 'images/four-squares.svg';
export const GREEN_CHECK = baseUrl + 'images/green-check.png';
export const HAM_BLUE = baseUrl + 'images/ham_blue.png';
export const HAM_GREY = baseUrl + 'images/ham-grey.png';
export const INFO_CIRCLE_SUCCESS = baseUrl + 'images/info-circle-success.png';
export const INFO_CIRCLE = baseUrl + 'images/info-circle.png';
export const INVISIBLE = baseUrl + 'images/invisible.svg';
export const ITCH = baseUrl + 'images/itch.svg';
export const KITCHEN_NOTES = baseUrl + 'images/kitchen-notes.png';
export const KITCHEN = baseUrl + 'images/kitchen.svg';
export const KN_STEP_1_PNG = baseUrl + 'images/kn-step-1.png';
export const KN_STEP_1_SVG = baseUrl + 'images/kn-step-1.svg';
export const LOCATION_BASED_PRICING_RM =
  baseUrl + 'images/location_based-pricing_rm.svg';
export const LOCATION_BASED_PRICING_RP =
  baseUrl + 'images/location_based-pricing_rp.svg';
export const LOGIN = baseUrl + 'images/login.svg';
export const LOGOUT = baseUrl + 'images/logout.svg';
export const LOW_STOCK_LEVEL_YELLOW =
  baseUrl + 'images/low_stock_level_yellow.svg';
export const LUNCH_BOX = baseUrl + 'images/lunch-box.svg';
export const MENU_3 = baseUrl + 'images/menu-3.png';
export const MULTIMEDIA_IMG = baseUrl + 'images/multimedia.svg';
export const NO_DATA = baseUrl + 'images/no-data.svg';
export const NO_ITEMS_FOUND = baseUrl + 'images/no-items-found.png';
export const NOTES_ICON = baseUrl + 'images/notes-icon.svg';
export const NOTES = baseUrl + 'images/notes.svg';
export const ORDER_FOOD = baseUrl + 'images/order-food.svg';
export const OUTLET_IMG = baseUrl + 'images/outlet.svg';
export const PAN = baseUrl + 'images/pan.svg';
export const PENCIL = baseUrl + 'images/pencil.svg';
export const PIZZA = baseUrl + 'images/pizza.svg';
export const PRICE_TAG = baseUrl + 'images/price-tag.svg';
export const PRICE_DETAIL = baseUrl + 'images/pricing-detail.png';
export const PRICE_DETAILS = baseUrl + 'images/pricing-details.svg';
export const SAUCES_3 = baseUrl + 'images/sauces-3.svg';
export const SEARCH_ICON = baseUrl + 'images/search-icon.svg';
export const SEARCH_NOT_FOUND = baseUrl + 'images/search-not-found.svg';
export const SEARCH = baseUrl + 'images/search.svg';
export const SETTLEMENT_CUSTOMER_LOGO = baseUrl + 'settlements-images/settlement_customer_logo.svg';
export const COLLECTS_PAYMENTS_LOGO = baseUrl + 'settlements-images/collects_payments_logo.svg';
export const MONEY_DEPOSIT_LOGO = baseUrl + 'settlements-images/money_deposit_logo.svg';
export const RED_ALERT_SETTLEMENT = baseUrl + 'settlements-images/red-alert-settlement.svg';
export const SETTLEMENT_HANDSHAKE_ICON = baseUrl + 'settlements-images/settlement-handshake-icon.svg';
export const SETTLEMENT_DOWNLOAD = baseUrl + 'settlements-images/settlement-download-logo.svg';
export const SETTLEMENT_DONE_ICON = baseUrl + 'settlements-images/settlement-done.svg';
export const SETTLEMENT_ALERT = baseUrl + 'settlements-images/settlement-alert.svg';
export const SETTLEMENT_COLLAPSED_ARROW = baseUrl + 'settlements-images/settlement-collapsed-arrow.svg';
export const SETTLEMENT_EXPANDED_ARROW = baseUrl + 'settlements-images/settlement-expended-arrow.svg';
export const SETTLEMENT_VIEW_DETAILS = baseUrl + 'settlements-images/view-details-arrow.svg';
export const COMMISSION_ALERT = baseUrl + 'settlements-images/commission-alert.svg';
export const SETTLEMENT_BREAKDOWN = baseUrl + 'settlements-images/settlement-breakdown.svg';
export const SETTLEMENT_COPY = baseUrl + 'settlements-images/settlement-copy.svg';
export const TAWA = baseUrl + 'images/tawa.png';
export const TIMER_ICON = baseUrl + 'images/timer-icon.svg';
export const UPLOAD_IMAGE_2 = baseUrl + 'images/upload-image-2.png';
export const UPLOAD_IMAGE_3 = baseUrl + 'images/upload-image-3.png';
export const UPLOAD_IMAGE_4 = baseUrl + 'images/upload-image-4.png';
export const UPLOAD_LOGO_1 = baseUrl + 'images/upload-logo-1.svg';
export const UPLOAD_LOGO_2 = baseUrl + 'images/upload-logo-2.svg';
export const UPLOAD_LOGO_3 = baseUrl + 'images/upload-logo-3.svg';
export const UPLOAD_LOGO_4 = baseUrl + 'images/upload-logo-4.png';
export const VISIBLE = baseUrl + 'images/visible.svg';
export const ADD_ON_TYPE = baseUrl + 'images/recipe-management/addon-type.svg';
export const BETA_TAG = baseUrl + 'images/recipe-management/betatag.svg';
export const CLOSE_RED = baseUrl + 'images/recipe-management/close_red.svg';
export const CLOSE_CIRCLE =
  baseUrl + 'images/recipe-management/close-circle.svg';
export const COMBO_TYPE = baseUrl + 'images/recipe-management/combo-type.svg';
export const COPY_ICON = baseUrl + 'images/recipe-management/copy_icon.svg';
export const CREATE_RECIPE =
  baseUrl + 'images/recipe-management/create-recipe.svg';
export const DELETE_ICON_RECIPE =
  baseUrl + 'images/recipe-management/delete_icon.svg';
export const EDIT_ICON_TABLE =
  baseUrl + 'images/recipe-management/edit_icon_table.svg';
export const INFO_ICON = baseUrl + 'images/recipe-management/info_icon.svg';
export const MAPPED_INFO = baseUrl + 'images/recipe-management/mapped_info.svg';
export const MENU_TYPE = baseUrl + 'images/recipe-management/menu-type.svg';
export const NO_INGRADIENT_IMG =
  baseUrl + 'images/recipe-management/no_ingradient_img.svg';
export const NO_INGRADIENT_FOUND =
  baseUrl + 'images/recipe-management/no-ingredient-found.svg';
export const RECIPE_NOT_FOUND =
  baseUrl + 'images/recipe-management/recipe_not_found.svg';
export const RECIPE_ALREADY_CREATED =
  baseUrl + 'images/recipe-management/recipe-already-created.svg';
export const SELECTION_NOT_ALLOWED =
  baseUrl + 'images/recipe-management/selection-not-allowed.svg';
export const VARIANT_TYPE =
  baseUrl + 'images/recipe-management/variant-type.svg';
export const VIDEO_ICON = baseUrl + 'images/recipe-management/video_icon.svg';

// LogIn
export const LOG_IN_1 = baseUrl + 'Login/1.png';
export const LOG_IN_2 = baseUrl + 'Login/2.png';
export const LOG_IN_3 = baseUrl + 'Login/3.png';
export const BACKGROUND = baseUrl + 'Login/background.jpg';
export const EASYEAT_SVG = baseUrl + 'Login/Easy Eat.svg';
export const HQ_BANNER = baseUrl + 'Login/hq-banner.png';
export const LOCK_SCREEN_BG = baseUrl + 'Login/lockScreen-bg.png';
export const LOGO_1 = baseUrl + 'Login/logo 1.svg';
export const LOGO_FULL = baseUrl + 'Login/logo full.svg';
export const LOGO_NEW = baseUrl + 'Login/logo-new.png';
export const PHONE_LOCK_BG = baseUrl + 'Login/phone-lock-bg.png';
export const TABLET_LOCK_BG = baseUrl + 'Login/tablet-lock-bg.png';
export const VALENTINE_IPAD_AIR = baseUrl + 'Login/valentine-ipad-air.png';
export const VALENTINE_PHONE = baseUrl + 'Login/valentine-phone.png';
export const VALENTINE_WEB = baseUrl + 'Login/valentine-web.webp';
export const POS_LOGO = baseUrl + 'Login/pos-logo.svg';
export const HQ_LOGO = baseUrl + 'Login/hq-logo.svg';
export const FMH_LOGO_LOGIN = baseUrl + 'Login/fmh-log.svg';
export const HQ_HUMAN = baseUrl + 'Login/hq-human.webp';
export const POS_HUMAN = baseUrl + 'Login/pos-human.webp';
export const SWITCH_ARROW = baseUrl + 'Login/switch-arrow.svg';
export const LOGIN_BG = baseUrl + 'Login/lock-screen-background.webp';
export const LOCKSCREEN_EID = baseUrl + 'Login/lockscreen-eid.webp';


// Lottie Animation
export const FOODPANDA_JSON = baseUrl + 'lottie-animation/foodpanda.json';
export const EDITOR_JSON =
  baseUrl + 'lottie-animation/lf30_editor_v5qx7unv.json';
export const SCAN_MENU_JSON = baseUrl + 'lottie-animation/scan-menu.json';
export const SUCCESS_JSON = baseUrl + 'lottie-animation/success.json';

// Loyalty Settings
export const LOYALITY_IMG = baseUrl + 'loyalty_settings/Loyality_Image.svg';
export const POINT = baseUrl + 'loyalty_settings/point.png';
export const PAUSE_LOYALTY = baseUrl + 'loyalty_settings/pause-loyalty.svg';

// Menu
export const MENU_STEP_URL = baseUrl + 'menu/step';
export const STEP_1 = baseUrl + 'menu/step1.svg';
export const STEP_2 = baseUrl + 'menu/step2.svg';
export const STEP_3 = baseUrl + 'menu/step3.svg';
export const STEP_4 = baseUrl + 'menu/step4.svg';
export const STEP_5 = baseUrl + 'menu/step5.svg';

// Orders
export const REMOVE_DISCOUNTS = baseUrl + 'orders/removeDiscount.png';
export const LOGO_EE = baseUrl + 'orders/Logo_EE.svg';
export const REC_ICON = baseUrl + 'orders/rec-icon.svg';
export const ARROW_DOWN_ORDER = baseUrl + 'orders/arrow_down.png';
export const BANNER_MASCOT = baseUrl + 'orders/banner-mascot.svg';
export const EXPERT_MASCOT = baseUrl + 'orders/expert-mascot.svg';
export const SUBSCRIPTION_FRAME = baseUrl + 'orders/subscription-renew.svg';
export const DROPDOWN_TOGGLE = baseUrl + 'orders/dropdown-toggle-img.svg';

export const SUBSCRIPTION_ALERT =
  baseUrl + 'orders/subscription-renew-alert.svg';
export const RENEWAL_CALENDAR =
  baseUrl + 'orders/renew-details-calendar-icon.svg';
export const RENEWAL_CALENDAR_BLACK =
  baseUrl + 'orders/renewal-calendar-black-img.svg ';
export const PAYMENT_SUCCESSFUL =
  baseUrl + 'orders/payment-status-successful.png';
export const PAYMENT_FAILURE = baseUrl + 'orders/payment-failed.svg';
export const WARNING_BANNER_IMG = baseUrl + 'orders/warning-banner-img.svg';
export const LOCKED_FEATURE_IMG = baseUrl + 'orders/locked-feature-img.svg';
export const MOST_POPULAR = baseUrl + 'orders/most-popular-img.svg';

export const HANDSHAKE = baseUrl + 'orders/OBJECTS.png';
export const CROSS_ORDER = baseUrl + 'orders/Close.png';
export const PAYMENT_IMG = baseUrl + 'orders/payment-img.png';
export const LOCKED = baseUrl + 'orders/locked.png';
export const LOCKED_SM = baseUrl + 'orders/locked_sm.png';
export const DOWNLOAD_DATA = baseUrl + 'orders/downloadData.svg';
export const ARROW_DOWN_SOLID = baseUrl + 'orders/arrow-down-solid.png';
export const ARROW_RIGHT_SOLID = baseUrl + 'orders/arrow-right-solid.png';
export const BIRTHDAY_BG = baseUrl + 'orders/birthday-bg.png';
export const BIRTHDAY_ICON = baseUrl + 'orders/birthday-icon.svg';
export const BIRTHDAY_JSON = baseUrl + 'orders/birthday.json';
export const BIRTHDAY = baseUrl + 'orders/birthday.svg';
export const BIRTHDAY_ANIMATION = baseUrl + 'orders/birthdayAnimation';
export const DISH_ITEM = baseUrl + 'orders/dish_item.png';
export const MONEY = baseUrl + 'orders/money.png';
export const NOT_PAID = baseUrl + 'orders/notpaid.svg';
export const NTH_ORDER = baseUrl + 'orders/nthorder.svg';
export const PAID = baseUrl + 'orders/paid.svg';
export const PAID_1 = baseUrl + 'orders/paid1.svg';
export const PARTIALLY_PAID = baseUrl + 'orders/partially_paid.svg';
export const SORT_ORDER = baseUrl + 'orders/sort.png';
export const TIMER = baseUrl + 'orders/timer.png';
export const TOP_1 = baseUrl + 'orders/top1.svg';
export const TOP_5 = baseUrl + 'orders/top5.svg';
export const TOP_10 = baseUrl + 'orders/top10.svg';
export const TOP_20 = baseUrl + 'orders/top20.svg';
export const TRIANGLE_DOWN = baseUrl + 'orders/triangle-down.png';
export const TRIANGLE_RIGHT = baseUrl + 'orders/triangle-right.png';
export const UNPAID = baseUrl + 'orders/unpaid.svg';
export const UPDATE_ORDER_TIMER_GREY =
  baseUrl + 'orders/updated-order-timer-grey.png';
export const UPDATE_ORDER_TIMER = baseUrl + 'orders/updated-order-timer.png';
export const EXPIRED_SCHEDULED_ORDER =
  baseUrl + 'orders/expired-order-icon.svg';

export const REOCCURING_INFO_ROBO = baseUrl + 'orders/reoccuring_info_robo.svg';
export const REFUND_ICON = baseUrl + 'orders/refund-icon.svg';
export const QR_CODE_FOR_AI = baseUrl + 'orders/customer-support-ai.svg';
export const QR_CODE_FOR_ID = baseUrl + 'orders/customer-support-id.svg';
export const LOCKED_IMG_LITE = baseUrl + 'orders/lite-locked.png';
export const BANNER_CROSS_ICON = baseUrl + 'orders/fmh-banner-cross-icon.webp';
export const MODAL_CROSS_ICON = baseUrl + 'orders/fmh-modal-cross.webp';
export const EE_FMH = baseUrl + 'orders/ee-fmh-ad.webp';
export const FMH_LOGO = baseUrl + 'orders/ee-fmh-logo.svg';
export const FMH_LOAN_LOGO = baseUrl + 'orders/fmh-loan-logo.svg';
export const HQ_LOAN_BANNER = baseUrl +'common/hq-banner.svg';
export const EE_FMH_ELIGIBLE_LOGO = baseUrl + 'orders/ee-eligible-logo.svg';
export const CLOSE_ELIGIBLE_ICON = baseUrl + 'orders/close-eligible-icon.svg';
export const RIGHT_ELIGIBLE_ICON = baseUrl + 'orders/right-eligible-icon.svg';
export const RED_BOX = baseUrl + 'orders/red-noneligible.svg';
export const DIAL_ICON = baseUrl + 'orders/flaginphone.svg';
export const EE_FMH_LOAN_POSTER = baseUrl + 'orders/ee-fmh-loan-poster.webp';
export const LOAN_BACKGROUND = baseUrl + 'orders/loan-feature-bg.webp';
export const MARKED_BACKGROUND = baseUrl + 'orders/marked-credit.webp';
export const MARKED_LOAN_ICON = baseUrl + 'orders/marked-loan-img.webp';
export const SEED_FLEX_IMAGE = baseUrl + 'orders/success-banner.webp';
export const FMH_LOGO_MOB = baseUrl + 'orders/fmh-logo-mob.svg ';
export const CONFIRMATION_FMH = baseUrl + 'orders/Confirmation ee-fmh.webp ';
export const EE_FMH_INDO = baseUrl + 'orders/EE_FMH_INDO.webp';
export const SEED_FLEX_SUCCESS = baseUrl + 'orders/seedflex-successfull.svg';
export const LOAN_CROSS_ICON = baseUrl + 'orders/close-loan-icon.svg ';
export const ALERT_FAILED = baseUrl + 'orders/alert-failed-payment.svg';
export const CASH_DRAWER_LOGO = baseUrl + 'orders/cash-drawer-icon.svg';
export const DYNAMIC_QR_LOGO = baseUrl + 'orders/dynamic-qr-icon.svg';
export const LOAN_ICON = baseUrl + 'orders/loan-icon-img.webp';

// POS
export const ADD_TO_ROOM = baseUrl + 'pos/addtoroom.svg';
export const AMERICAN_EXPRESS = baseUrl + 'pos/american_express.png';
export const BG_8 = baseUrl + 'pos/bg8.jpg';
export const BIG_PAY = baseUrl + 'pos/bigpay.png';
export const BOOST = baseUrl + 'pos/boost.png';
export const CROSS_ICON_POS = baseUrl + 'pos/cross.svg';
export const DELIVER_EAT = baseUrl + 'pos/deliver_eat.png';
export const DINNING_ROOM = baseUrl + 'pos/dining_room.svg';
export const EATIGO = baseUrl + 'pos/eatigo.jpg';
export const FAVE = baseUrl + 'pos/fave.png';
export const FP_SETTLE = baseUrl + 'pos/fp_settle.png';
export const FTUE_CLOSE = baseUrl + 'pos/ftue_close.svg';
export const MODAL_CLOSE_RED = baseUrl + 'pos/modal_close_red.svg';
export const GB_SETTLE = baseUrl + 'pos/gb_settle.png';
export const GO_EAT = baseUrl + 'pos/go_eat.png';
export const GRAB_POS = baseUrl + 'pos/grab.png';
export const HUNGRY_2U = baseUrl + 'pos/hungry2u.png';
export const INPUT_INDICATOR = baseUrl + 'pos/input-indicator.jpg';
export const KLOOK_LOGO = baseUrl + 'pos/klook_logo.png';
export const LAZADA_LOGO = baseUrl + 'pos/lazada-logo.png';
export const LOLOL = baseUrl + 'pos/lolol.png';
export const LOYALITY_CUSTOMER = baseUrl + 'pos/loyality-customer.svg';
export const LUNCH = baseUrl + 'pos/lunch.svg';
export const MAP = baseUrl + 'pos/map.svg';
export const MASTER_CARD = baseUrl + 'pos/Mastercard.svg';
export const MAY_BANK_QR = baseUrl + 'pos/maybankqr.jpeg';
export const MONEY_IMG = baseUrl + 'pos/moneyimg.svg';
export const NON_VEG_ICON = baseUrl + 'pos/non-veg-icon.png';
export const ODDLE_LOGO = baseUrl + 'pos/oddle-logo.jpg';
export const ONLINE_BANKING = baseUrl + 'pos/online_banking.png';
export const OTHER_PLATEFORM = baseUrl + 'pos/others_platform.svg';
export const PANDA = baseUrl + 'pos/panda.png';
export const PEN_2X = baseUrl + 'pos/pen2x.svg';
export const PERSON = baseUrl + 'pos/person.svg';
export const PHONE_2 = baseUrl + 'pos/phone-2.svg';
export const PRINT = baseUrl + 'pos/print.svg';
export const QRIS_ANIMATION = baseUrl + 'pos/qris_animation.gif';
export const QRIS_BG = baseUrl + 'pos/qris_bg.svg';
export const DUITNOW = baseUrl + 'pos/duitnow.png';
export const QR_LOADER = baseUrl + 'pos/qr-loader.gif';
export const DUIT_NOW = baseUrl + 'pos/duit_now.svg';
export const DN_GRAB_PAY = baseUrl + 'pos/dn_grab_pay.webp';
export const DN_TNG = baseUrl + 'pos/dn_tng.webp';
export const DN_BOOST = baseUrl + 'pos/dn_boost.webp';
export const DN_MAYBANK = baseUrl + 'pos/dn_maybank.webp';
export const DN_SHOPEE_PAY = baseUrl + 'pos/dn_shopee_pay.webp';
export const DN_ALL = baseUrl + 'pos/dn_all.webp';
export const RIGHT_ARROW = baseUrl + 'pos/right_arrow.png';
export const SHOPEE_LOGO = baseUrl + 'pos/shopee_logo.svg';
export const SPLIT_BILL = baseUrl + 'pos/Split Bill.svg';
export const TABLE_NO = baseUrl + 'pos/table_no.svg';
export const THIRD_PARTY_VOUCHER = baseUrl + 'pos/thirdpartyvoucher.svg';
export const TOUCH_AND_GO = baseUrl + 'pos/touchngo.jpeg';
export const VEG_ICON_POS = baseUrl + 'pos/veg-icon.png';
export const VISA = baseUrl + 'pos/Visa.svg';
export const SERVE_TABLE = baseUrl + 'pos/serve_table.svg';
export const SERVE_TABLE_ICON = baseUrl + 'pos/serve_table_icon.svg';

// Printer
export const PRINTERS_URL = baseUrl + 'printers/';
export const ACTIVATED_PRINTER = baseUrl + 'printers/printer-icon-enabled.svg';
export const DEACTIVATED_PRINTER =
  baseUrl + 'printers/printer-icon-disabled.svg';
export const BACK_BUTTON = baseUrl + 'printers/back-button.svg';
export const CLOSE_PRINTER = baseUrl + 'printers/close.svg';
export const CONNECTED_ICON = baseUrl + 'printers/connected-icon.svg';
export const DISCONNECTED_ICON = baseUrl + 'printers/disconnected-icon.svg';
export const ERROR_PRINTER = baseUrl + 'printers/error.svg';
export const LAN_IMG = baseUrl + 'printers/lan-img.svg';
export const PRINTER_ICON = baseUrl + 'printers/printer_icon.svg';
export const PRINTER_CONNECT = baseUrl + 'printers/printer-connect.svg';
export const PRINTER_DISCONNECT = baseUrl + 'printers/printer-disconnect.svg';
export const RETRY_ICON = baseUrl + 'printers/retry-icon.svg';
export const RETRY = baseUrl + 'printers/retry.svg';
export const SUCCESS_PRINTER = baseUrl + 'printers/success.svg';
export const WIFI_IMG = baseUrl + 'printers/wifi-img.svg';
export const RIGHT_ARROW_ICON_BLUE = baseUrl + 'printers/right-arrow.svg';
export const RIGHT_ARROW_ICON_GREEN =
  baseUrl + 'printers/right-arrow-green.svg';
export const PRINTER_DISCONNECTED_ICON =
  baseUrl + 'printers/printer-disconnected.svg';
export const PRINTER_DELAY_ICON = baseUrl + 'printers/printing-delay.svg';
export const PRINTER_DELAY_ICON_GREEN =
  baseUrl + 'printers/no-print-delay-green.svg';
export const PRINTER_LIST_ICON = baseUrl + 'printers/printer-list-icon.svg';
export const PRINTER_LIST_ICON_GREEN =
  baseUrl + 'printers/printer-list-icon-green.svg';
export const NO_EVENTS_DELAY_IMG = baseUrl + 'printers/no-delay-img.svg';
export const PRINTER_STEP = baseUrl + 'printers/printer-step.svg';
export const WIFI_STEP = baseUrl + 'printers/wifi-step-icon.svg';
export const PRINTER_STEP_1 = baseUrl + 'printers/printer-step-1.jpg';
export const PRINTER_STEP_2 = baseUrl + 'printers/printer-step-2.jpg';
export const PRINTER_STEP_3 = baseUrl + 'printers/printer-step-3.jpg';
export const PRINTER_STEP_4 = baseUrl + 'printers/printer-step-4.jpg';
export const WIFI_STEP_1 = baseUrl + 'printers/wifi-step-1.jpg';
export const ROTATING_ARROW = baseUrl + 'printers/rotating-arrow.svg';
export const PRINTER_BTN_ICON = baseUrl + 'printers/printer-btn-icon.svg';
export const PRINTER_STATUS_CONNECTION =
  baseUrl + 'printers/printer-status-connection.svg';
export const PRINTER_VIDEO_1 = baseUrl + 'printers/printer-video-1.mp4';
export const PRINTER_VIDEO_2 = baseUrl + 'printers/printer-video-2.mp4';

// Promotions
export const PROMOTIONS_URL = baseUrl + 'promotions/';
export const BANKRUPTCY = baseUrl + 'promotions/bankruptcy.png';
export const BOGO = baseUrl + 'promotions/bogo.png';
export const BOGO_1 = baseUrl + 'promotions/bogo1.svg';
export const BXGYZ = baseUrl + 'promotions/bxgyz.png';
export const FIXED = baseUrl + 'promotions/fixed.png';
export const FIXED_1 = baseUrl + 'promotions/fixed1.svg';
export const FREE = baseUrl + 'promotions/free.png';
export const GROUP_21185 = baseUrl + 'promotions/Group 21185.png';
export const LINEAR = baseUrl + 'promotions/linear.png';
export const OFFER_ICON = baseUrl + 'promotions/offer-icon.svg';
export const PAGE_1 = baseUrl + 'promotions/Page-1.png';
export const PERCENTAGE = baseUrl + 'promotions/percentage.png';
export const PRICE_TAG_PROMOTION = baseUrl + 'promotions/price-tag.png';

// Referral
export const REFERRAL = baseUrl + 'referral/referral.png';

// ROI
export const DELIVERY_COMMISSION_SAVED =
  baseUrl + 'roi/Delivery Commission Saved.json';
export const FEE = baseUrl + 'roi/fee.svg';
export const HARDWARE_COST_SAVED = baseUrl + 'roi/Hardware costs Saved.svg';
export const LANDING_PAGE_IMAGE = baseUrl + 'roi/Landing Page image.svg';
export const LOCATION = baseUrl + 'roi/location.svg';
export const POS_SOFTWARE_SUBSCRIPTION =
  baseUrl + 'roi/POS software subscription saved.svg';
export const POS = baseUrl + 'roi/pos.svg';
export const QR_ORDER_JSON = baseUrl + 'roi/QR Order.json';
export const QR_SVG = baseUrl + 'roi/qr.svg';
export const REVENUE_FROM_LOYALTY =
  baseUrl + 'roi/Revenue from Loyalty Program.json';
export const ROI_BANNER = baseUrl + 'roi/roi-banner.svg';
export const SETTING = baseUrl + 'roi/setting.svg';
export const TECHNOLOGY_FEE_SAVED = baseUrl + 'roi/technology Fees Saved.svg';
export const TICK_ROI = baseUrl + 'roi/tick.svg';

// Server
export const ASPECT_RATIO_MATERIAL =
  baseUrl + 'server/aspect-ratio-material.png';
export const MONEY_SERVER = baseUrl + 'server/money.png';
export const SERVER_IMG = baseUrl + 'server/server.png';

// Settlement Dashboard
export const EE_EASYEAT = baseUrl + 'collection-infrastructure/ee-img.svg';
export const LEFT = baseUrl + 'settlement/ai/left.svg';
export const RIGHT = baseUrl + 'settlement/ai/right.svg';
export const GROUP_21098 = baseUrl + 'settlement/ai/Group 21098.svg';

// Side Nav
export const ANALYTICS = baseUrl + 'sidenav/analytics.svg';
export const COGWHEEL = baseUrl + 'sidenav/cogwheel.svg';
export const TABLE_RESERVATION = baseUrl + 'sidenav/table-reservation.svg';
export const AI_SIDENAV_ICON = baseUrl + 'sidenav/ai-icon.svg';
export const DINING_ROOM = baseUrl + 'sidenav/dining_room.svg';
export const DINING_TABLE = baseUrl + 'sidenav/dining-table.svg';
export const DISCOUNT_SIDENAV = baseUrl + 'sidenav/discount.svg';
export const EE_HQ = baseUrl + 'sidenav/ee-hq.svg';
export const INTEGRATION = baseUrl + 'sidenav/integration.svg';
export const INVENTORY = baseUrl + 'sidenav/inventory.svg';
export const INVOICE = baseUrl + 'sidenav/invoice.svg';
export const MARKETING = baseUrl + 'marketing.gif';
export const NAV_CHAIR = baseUrl + 'sidenav/nav_chair.png';
export const NAV_DASH = baseUrl + 'sidenav/nav_dash.svg';
export const NAV_LAYALTY_SETTING = baseUrl + 'sidenav/nav_loyalty_setting.svg';
export const NAV_MENU = baseUrl + 'sidenav/nav_menu.svg';
export const NAV_ORDER = baseUrl + 'sidenav/nav_order.svg';
export const NAV_SEATING = baseUrl + 'sidenav/nav_seating.svg';
export const NAV_SECTION = baseUrl + 'sidenav/nav_section.svg';
export const NAV_STAFF = baseUrl + 'sidenav/nav_staff.svg';
export const QR_JIBRIL_1 = baseUrl + 'sidenav/qr_jibril_1.png';
export const QR_JIBRIL_3 = baseUrl + 'sidenav/qr_jibril_3.png';
export const QR_JIBRIL_A2 = baseUrl + 'sidenav/qr_jibril_a2.png';
export const QR = baseUrl + 'sidenav/qr.png';
export const QUESTION = baseUrl + 'sidenav/question.svg';
export const REFERRAL_SIDENAV = baseUrl + 'sidenav/referral_sidenav.png';
export const RESTAURANT = baseUrl + 'sidenav/restaurant.png';
export const SETTLEMENT = baseUrl + 'sidenav/settlement.png';
export const SITTING_CHAIR = baseUrl + 'sidenav/sitting-chair.png';
export const STORE = baseUrl + 'sidenav/store.svg';

// Modern Sidenav group icons
export const SIDENAV_GROUP = baseUrl + 'sidenav-icons/group/';
export const BUSINESS_MANAGEMENT = SIDENAV_GROUP + 'business_management.svg';
export const MENU_MARKETING = SIDENAV_GROUP + 'menu_marketing.svg';
export const MENU_PROMOTIONS = SIDENAV_GROUP + 'menu_promotions.svg';
export const ORDER_DINING = SIDENAV_GROUP + 'order_dining.svg';
export const PERFORMANCE_INSIGHTS = SIDENAV_GROUP + 'performance_insights.svg';
export const REPORT_ANALYTICS = SIDENAV_GROUP + 'report_analytics.svg';
export const SETTINGS_SUPPORT = SIDENAV_GROUP + 'settings_support.svg';

// Modern Sidenav group selected icons
export const BUSINESS_MANAGEMENT_SELECTED = SIDENAV_GROUP + 'business_management_s.svg';
export const MENU_MARKETING_SELECTED = SIDENAV_GROUP + 'menu_marketing_s.svg';
export const MENU_PROMOTIONS_SELECTED = SIDENAV_GROUP + 'menu_promotions_s.svg';
export const ORDER_DINING_SELECTED = SIDENAV_GROUP + 'order_dining_s.svg';
export const PERFORMANCE_INSIGHTS_SELECTED = SIDENAV_GROUP + 'performance_insights_s.svg';
export const REPORT_ANALYTICS_SELECTED = SIDENAV_GROUP + 'report_analytics_s.svg';
export const SETTINGS_SUPPORT_SELECTED = SIDENAV_GROUP + 'settings_support_s.svg';

// Modern Sidenav item icons
export const SIDENAV_ITEM = baseUrl + 'sidenav-icons/items/';
export const ORDER_DASHBOARD = SIDENAV_ITEM + 'order_dashboard.svg';
export const TABLE = SIDENAV_ITEM + 'table.svg';
export const TABLE_BOOKINGS = SIDENAV_ITEM + 'table_reservation.svg';
export const TABLE_SERVICE = SIDENAV_ITEM + 'table_service.svg';
export const MODERN_MENU = SIDENAV_ITEM + 'menu.svg';
export const PROMOTIONS = SIDENAV_ITEM + 'promotion.svg';
export const REPORTS = SIDENAV_ITEM + 'reports.svg';
export const RESTAURANT_ANALYTICS = SIDENAV_ITEM + 'restaurant_analytics.svg';
export const SECTIONS_COUNTERS = SIDENAV_ITEM + 'sections_counters.svg';
export const RESTAURANT_DETAILS = SIDENAV_ITEM + 'restaurant_details.svg';
export const APP_SETTINGS = SIDENAV_ITEM + 'app_setting.svg';
export const MODERN_INVENTORY = SIDENAV_ITEM + 'inventory.svg';
export const HELP_CENTER = SIDENAV_ITEM + 'help_center.svg';
export const ORDER_DASHBOARD_NEW = SIDENAV_ITEM + 'order_dashboard_new.svg';
export const MODERN_MENU_NEW = SIDENAV_ITEM + 'menu_new.svg';


// Modern Sidenav selected item icons
export const ORDER_DASHBOARD_SELECTED = SIDENAV_ITEM + 'order_dashboard_s.svg';
export const TABLE_SELECTED = SIDENAV_ITEM + 'table_s.svg';
export const TABLE_BOOKINGS_SELECTED = SIDENAV_ITEM + 'table_reservation_s.svg';
export const TABLE_SERVICE_SELECTED = SIDENAV_ITEM + 'table_service_s.svg';
export const MODERN_MENU_SELECTED = SIDENAV_ITEM + 'menu_s.svg';
export const PROMOTIONS_SELECTED = SIDENAV_ITEM + 'promotion_s.svg';
export const REPORTS_SELECTED = SIDENAV_ITEM + 'reports_s.svg';
export const RESTAURANT_ANALYTICS_SELECTED = SIDENAV_ITEM + 'restaurant_analytics_s.svg';
export const SECTIONS_COUNTERS_SELECTED = SIDENAV_ITEM + 'sections_counters_s.svg';
export const RESTAURANT_DETAILS_SELECTED = SIDENAV_ITEM + 'restaurant_details_s.svg';
export const APP_SETTINGS_SELECTED = SIDENAV_ITEM + 'app_setting_s.svg';
export const MODERN_INVENTORY_SELECTED = SIDENAV_ITEM + 'inventory_s.svg';
export const HELP_CENTER_SELECTED = SIDENAV_ITEM + 'help_center_s.svg';
export const ORDER_DASHBOARD_SELECTED_NEW = SIDENAV_ITEM + 'order_dashboard_s_new.svg';
export const MODERN_MENU_SELECTED_NEW = SIDENAV_ITEM + 'menu_s_new.svg';


// HQ-specific icons (regular and selected versions)
export const HQ_DASHBOARD = SIDENAV_ITEM + 'hq_dashboard.svg';
export const HQ_DASHBOARD_SELECTED = SIDENAV_ITEM + 'hq_dashboard_s.svg';
export const HQ_ORDERS = SIDENAV_ITEM + 'hq_orders.svg';
export const HQ_ORDERS_SELECTED = SIDENAV_ITEM + 'hq_orders_s.svg';
export const HQ_OUTLETS = SIDENAV_ITEM + 'hq_outlets.svg';
export const HQ_OUTLETS_SELECTED = SIDENAV_ITEM + 'hq_outlets_s.svg';
export const HQ_BILLING = SIDENAV_ITEM + 'hq_billing.svg';
export const HQ_BILLING_SELECTED = SIDENAV_ITEM + 'hq_billing_s.svg';
export const HQ_SETTLEMENT = SIDENAV_ITEM + 'hq_settlement.svg';
export const HQ_SETTLEMENT_SELECTED = SIDENAV_ITEM + 'hq_settlement_s.svg';
export const HQ_STAFF_CENTER = SIDENAV_ITEM + 'hq_staff_center.svg';
export const HQ_STAFF_CENTER_SELECTED = SIDENAV_ITEM + 'hq_staff_center_s.svg';
export const HQ_INVENTORY = SIDENAV_ITEM + 'hq_inventory.svg';
export const HQ_INVENTORY_SELECTED = SIDENAV_ITEM + 'hq_inventory_s.svg';
export const HQ_E_INVOICE = SIDENAV_ITEM + 'hq_e_invoice.svg';
export const HQ_E_INVOICE_SELECTED = SIDENAV_ITEM + 'hq_e_invoice_s.svg';
export const HQ_MENU_DISHES = SIDENAV_ITEM + 'hq_menu_dishes.svg';
export const HQ_MENU_DISHES_SELECTED = SIDENAV_ITEM + 'hq_menu_dishes_s.svg';
export const HQ_SMS_MARKETING = SIDENAV_ITEM + 'hq_sms_marketing.svg';
export const HQ_SMS_MARKETING_SELECTED = SIDENAV_ITEM + 'hq_sms_marketing_s.svg';
export const HQ_LOYALTY = SIDENAV_ITEM + 'hq_loyalty.svg';
export const HQ_LOYALTY_SELECTED = SIDENAV_ITEM + 'hq_loyalty_s.svg';
export const HQ_REFERRAL = SIDENAV_ITEM + 'hq_referral.svg';
export const HQ_REFERRAL_SELECTED = SIDENAV_ITEM + 'hq_referral_s.svg';
export const HQ_INTEGRATIONS = SIDENAV_ITEM + 'hq_integrations.svg';
export const HQ_INTEGRATIONS_SELECTED = SIDENAV_ITEM + 'hq_integrations_s.svg';
export const HQ_HELP_CENTER = SIDENAV_ITEM + 'hq_help_center.svg';
export const HQ_HELP_CENTER_SELECTED = SIDENAV_ITEM + 'hq_help_center_s.svg';
export const HQ_RESTAURANT_DETAILS_SELECTED = SIDENAV_ITEM + 'hq_restaurant_details_s.svg';
export const HQ_PROMOTIONS_SELECTED = SIDENAV_ITEM + 'hq_promotions_s.svg';
export const HQ_REPORTS_SELECTED = SIDENAV_ITEM + 'hq_reports_s.svg';
export const HQ_RESTAURANT_ANALYTICS_SELECTED = SIDENAV_ITEM + 'hq_restaurant_analytics_s.svg';
export const HQ_REFERAL = SIDENAV_ITEM + 'hq_referal.svg';
export const HQ_REFERAL_SELECTED = SIDENAV_ITEM + 'hq_referal_s.svg';
export const HQ_ORDERS_ICON_SELECTED = SIDENAV_ITEM + 'hq_orders_s.svg';
export const HQ_CUSTOMER_DISPLAY = SIDENAV_ITEM + 'hq_customer_display.svg';
export const HQ_CUSTOMER_DISPLAY_SELECTED = SIDENAV_ITEM + 'hq_customer_display_s.svg';

// HQ SPECIFIC SELECTED GROUP ICONS
export const HQ_SETTINGS_SELECTED = SIDENAV_GROUP + 'hq_settings_s.svg';


// Legacy naming for backward compatibility
export const ORDER_DASHBOARD_MODERN = ORDER_DASHBOARD_SELECTED;

// FMH onboard modal
export const EE_FMH_LOGO = baseUrl + 'sidenav-icons/modals/fmh_easyeat_logo.svg';
export const FMH_CHEF = baseUrl + 'sidenav-icons/modals/chef.svg';

// EXTRA ICONS
export const SIDENAV_ITEM_EXTRA = baseUrl + 'sidenav-icons/extra/';
export const SIDENAV_FMH_LOGO = SIDENAV_ITEM_EXTRA +'fmh_logo.svg';
export const LOGOUT_ICON = SIDENAV_ITEM_EXTRA +'logout.svg';
export const FMH_BACKGROUND = SIDENAV_ITEM_EXTRA +'fmh_background.svg';
export const LOCK_ICON = SIDENAV_ITEM_EXTRA +'lock.svg';
export const ARROW_DOWN_ACTIVE = SIDENAV_ITEM_EXTRA +'down_arrow_selected.svg';
export const LOGOUT_ICON_HOVER = SIDENAV_ITEM_EXTRA +'logout-light.svg';
export const ARROW_LEFT = SIDENAV_ITEM_EXTRA +'arrow-left.svg';
export const ARROW_RIGHT = SIDENAV_ITEM_EXTRA +'arrow-right.svg';
export const LOCK_ICON_HOVER = SIDENAV_ITEM_EXTRA +'lock_hover.svg';

// SQL Integration
export const SQL_INTEGRATION_URL = baseUrl + 'sql-integration/';
export const CANCEL_BUTTON = baseUrl + 'sql-integration/cancel-button.svg';
export const CATEGORY_REPORT = baseUrl + 'sql-integration/category-report.svg';
export const CATEGORY_XLSX = baseUrl + 'sql-integration/category-xlsx.svg';
export const FAILED_JSON = baseUrl + 'sql-integration/failed.json';
export const FILE_DOWNLOAD = baseUrl + 'sql-integration/file-download.svg';
export const FILE_EDIT = baseUrl + 'sql-integration/file-edit.svg';
export const FILE_UPLOAD = baseUrl + 'sql-integration/file-upload.svg';
export const FOOD_MARKET = baseUrl + 'sql-integration/foodmarket.svg';
export const FOODPANDA_SQL = baseUrl + 'sql-integration/foodpanda.svg';
export const GRAB_LARGE_SQL = baseUrl + 'sql-integration/grablarge.png';
export const ITEM_REPORT = baseUrl + 'sql-integration/item-report.svg';
export const PAYMENT_REPORT = baseUrl + 'sql-integration/payment-report.svg';
export const PAYMENT_XLSX = baseUrl + 'sql-integration/payment-xlsx.svg';
export const REPORT_GENERATE = baseUrl + 'sql-integration/report-generate.svg';
export const REPORT_SEND_JSON = baseUrl + 'sql-integration/report-send.json';
export const SQL = baseUrl + 'sql-integration/sql.svg';
export const SUCCESSFUL_JSON = baseUrl + 'sql-integration/successful.json';
export const TICK_SQL = baseUrl + 'sql-integration/tick.svg';
export const TABLE_CHANGE_GIF = baseUrl + 'orders/table-change.gif';
export const REMOVE_DISCOUNT = baseUrl + 'orders/removeDiscount.gif';
export const NEW_TICK = baseUrl + 'orders/tickO.png';
export const NEW_EE = baseUrl + 'orders/ee.png';

// Staff
export const CHECKED = baseUrl + 'staff/checked.png';
export const CROSS_ICON_STAFF = baseUrl + 'staff/cross.png';
export const DELETE_ROLE_ICON = baseUrl + 'staff/delete_role.svg';

// Tables layout
export const CLOCK = baseUrl + 'tables-layout/clock.svg';
export const MEAT = baseUrl + 'tables-layout/meat.svg';
export const MONEY_TABLE_LAYOUT = baseUrl + 'tables-layout/money.png';
export const NO_CHANNEL_ORDERS =
  baseUrl + 'tables-layout/no-channel-orders.svg';
export const ORDER = baseUrl + 'tables-layout/order.svg';
export const PLUS = baseUrl + 'tables-layout/plus.svg';
export const USER_TABLE_LAYOUT = baseUrl + 'tables-layout/user.svg';

// Tables
export const CONTACTLESS_MENU = baseUrl + 'tables/contactless_menu.svg';
export const CONTACTLESS_ORDER = baseUrl + 'tables/contactless_order.svg';
export const CONTACTLESS_PAY = baseUrl + 'tables/contactless_pay.svg';
export const DELETE_TABLES = baseUrl + 'tables/delete.png';
export const EDIT_TABLES = baseUrl + 'tables/edit.svg';
export const GROUP_237 = baseUrl + 'tables/Group 237.svg';
export const MASK_GROUP_8 = baseUrl + 'tables/Mask Group 8.png';
export const MENU_FORK = baseUrl + 'tables/menu_fork.svg';
export const RUBBISH = baseUrl + 'tables/rubbish.png';
export const TEST_REST = baseUrl + 'tables/test_rest.png';
export const TRASH_TABLES = baseUrl + 'tables/trash.png';

// Table Service
export const CASH_TABLE_SERVICE = baseUrl + 'tableservice/cash.svg';
// Marketing
export const FULL_MOBILE = baseUrl + 'marketing/ai/Dark.png';
export const MARKETING_POSTER = baseUrl + 'marketing/ai/poster.png';
export const MARKETING_VIDEO = baseUrl + 'marketing/ai/marketing.mp4';
export const NO_CAMPAIGN = baseUrl + 'marketing/ai/nocamp.png';
export const FEATURE = baseUrl + 'marketing/ai/drip.png';
export const END_MARKETING = baseUrl + 'marketing/ai/end.svg';
export const SENT_MESSAGE_IMG = baseUrl + 'marketing/ai/sent_message.webp';
export const INFO_YELLOW = baseUrl + 'marketing/ai/info_yellow.svg';
export const AUTOMATE_ICON = baseUrl + 'marketing/ai/auto_mate.svg';
export const ONETIME_ICON = baseUrl + 'marketing/ai/one_time.svg';
export const AUTOMATE = baseUrl + 'marketing/ai/automate.png';
export const ONETIME = baseUrl + 'marketing/ai/oneTime.png';
export const SUCCESS = baseUrl + 'marketing/ai/success.svg';
export const O_STEPS = baseUrl + 'marketing/ai/onetimeStep.png';
export const REVIEW = baseUrl + 'marketing/ai/review.png';
export const REVIEW_LOGO = baseUrl + 'marketing/ai/review_logo.svg';
export const WINBACK = baseUrl + 'marketing/ai/winback.png';
export const WINBACK_LOGO = baseUrl + 'marketing/ai/winback_logo.svg';
export const WELCOME = baseUrl + 'marketing/ai/welcome.png';
export const WELCOME_LOGO = baseUrl + 'marketing/ai/welcome_logo.svg';
export const REVENUE = baseUrl + 'marketing/ai/revenue.svg';
export const REACHED = baseUrl + 'marketing/ai/reached.svg';
export const CREDIT = baseUrl + 'marketing/ai/Credit.svg';
export const SENT = baseUrl + 'marketing/ai/sent.svg';
export const COST = baseUrl + 'marketing/ai/cost.svg';
export const SMS_CREDIT = baseUrl + 'marketing/ai/smsCredit.svg';

// Payments
export const WAITING = baseUrl + 'payments/waiting.svg';
export const QRLOGO = baseUrl + 'payments/QR.webp';
export const EDC = baseUrl + 'payments/POS.webp';
export const EDC_BADGE = baseUrl + 'payments/EDCBadge.png';
export const QR_BADGE = baseUrl + 'payments/QRBadge.png';
export const PAYMENT_FAIL_GIF = baseUrl + 'payments/payment_fail.gif';
export const MINIMINZE = baseUrl + 'payments/minimize.png';
export const PAYMENT_SUCCESS_SVG = baseUrl + 'payments/payment_success.svg';
export const CLOSE_ICON_GRAY = baseUrl + 'payments/close_icon.png';

export const PINE_LAB_TERMINAL = baseUrl + 'payments/pinelabterminal.svg';
export const PINE_LAB_TIMEOUT = baseUrl + 'payments/timeout.svg';

export const PINE_LAB_STAFF_GUIDE_S1 = baseUrl + 'payments/staff_guide_s1.svg';
export const PINE_LAB_STAFF_GUIDE_S2 = baseUrl + 'payments/staff_guide_s2.svg';
export const PINE_LAB_STAFF_GUIDE_S3 = baseUrl + 'payments/staff_guide_s3.svg';
export const PINE_LAB_STAFF_GUIDE_S4 = baseUrl + 'payments/staff_guide_s4.svg';
export const PINE_LAB_STAFF_GUIDE_S5 = baseUrl + 'payments/staff_guide_s5.svg';
export const PINE_LAB_STAFF_GUIDE_S6 = baseUrl + 'payments/staff_guide_s6.svg';
export const PINE_LAB_MAX_ICON = baseUrl + 'payments/maximize_icon.svg';

// Inventory
export const ADD_FILE = baseUrl + 'inventory/add-file.svg';
export const REMOVE_FILE = baseUrl + 'inventory/remove-file.svg';
export const INFO_ICON_INVENTORY = baseUrl + 'inventory/info-icon.svg';
export const ERROR_ICON = baseUrl + 'inventory/error-icon.svg';

// Stock Transfer
export const ADD_INGREDIANT =
  baseUrl + 'inventory/stock-transfer/add-ingredient.svg';
export const CREATE_TRANSFER_DESC =
  baseUrl + 'inventory/stock-transfer/create-transfer-desc.svg';
export const DOWNLOAD_CK =
  baseUrl + 'inventory/stock-transfer/download-icon.svg';
export const INFO_CK = baseUrl + 'inventory/stock-transfer/info-icon.svg';
export const SEARCH_ICON_CK =
  baseUrl + 'inventory/stock-transfer/search-icon.svg';
export const CLOSE_ICON_CK =
  baseUrl + 'inventory/stock-transfer/close-icon.svg';
export const WARNING_ICON_CK =
  baseUrl + 'inventory/stock-transfer/warning-icon.svg';
export const NO_ORDERS_FOUND_CK =
  baseUrl + 'inventory/stock-transfer/no-orders.svg';

// Header
export const STAR_COIN = baseUrl + 'header/star-coin.svg';
export const EARNING_REC = baseUrl + 'header/earing-rec.svg';
export const EARNING_LOYALTY = baseUrl + 'header/earning-loyalty.svg';
export const EARNING_QR = baseUrl + 'header/earning-qr.svg';
export const EE_CLOSE = baseUrl + 'header/ee-close.svg';
export const EE_VALUE = baseUrl + 'header/ee-value.svg';
export const EE_LOGO = baseUrl + 'header/ee-logo-text.svg';

// Ukirama screen
export const BACK_ARROW_UK = baseUrl + 'sql-integration/backArrow.svg';
export const EASY_EAT_UK = baseUrl + 'sql-integration/easyEat.svg';
export const VERIFICATION_SUCCESS_UK =
  baseUrl + 'sql-integration/verification-success.svg';
export const VERIFICATION_FAIL_UK =
  baseUrl + 'sql-integration/verification-fail.svg';
export const HOST_SERVER_UK = baseUrl + 'sql-integration/host-server.svg';
export const HOST_URL_UK = baseUrl + 'sql-integration/host-url.svg';
export const CLOSE_UK = baseUrl + 'sql-integration/Close.svg';
export const DEMO_UK = baseUrl + 'sql-integration/demo.svg';
export const DATA_SYNC_UK = baseUrl + 'sql-integration/dataSync.svg';
export const API_TOKEN_UK = baseUrl + 'sql-integration/api-token.svg';
export const DATA_SYNC_ROTATION_UK =
  baseUrl + 'sql-integration/data-sync-rotation.gif';
export const DATA_SYNC_UKIRAMA_UK =
  baseUrl + 'sql-integration/data-sync-ukirama.svg';
export const REPORT_GENERATE_UK =
  baseUrl + 'sql-integration/report-generate.svg';
export const ROBOT_UK = baseUrl + 'sql-integration/robot.svg';
export const STEP_BY_STEP_INTEGRATION_UK =
  baseUrl + 'sql-integration/Step-by-Step-Integration-with-Ukirama.pdf';
export const TICK_UK = baseUrl + 'sql-integration/tick.svg';
export const UKIRAMA_ACCOUNTING_UK =
  baseUrl + 'sql-integration/ukiramaAccounting.png';
export const CLOCK_UK = baseUrl + 'sql-integration/clock.svg';
export const ROI = baseUrl + 'roi/roi-banner.svg';

export const GRAY_CLOSE_IMG = baseUrl + 'payments/close_icon.png';

export const SCAN_QR_AD = baseUrl + 'pos/scan-qr-ad.png';
export const CLOSE_TRANSPARENT = baseUrl + 'pos/close_transparent.svg';
export const SCAN_QR_ICON = baseUrl + 'pos/scan-qr-icon.gif';
export const QR_RANK = baseUrl + 'pos/qr-rank.svg';
export const INFO_TRANSPARENT = baseUrl + 'pos/info-transparent.svg';
export const WHITE_BACK_ARROW = baseUrl + 'pos/white-back-arrow.svg';
export const SCAN_N_WIN_ROBO = baseUrl + 'pos/scan-n-win-robo.svg';
export const SCAN_N_WINPRIZE = baseUrl + 'pos/scan-n-winprize.svg';
export const SCAN_N_WIN = baseUrl + 'pos/scan-n-win.svg';
export const SCAN_N_WIN_PREV_WINNER =
  baseUrl + 'pos/scan-n-win-prev-winner.svg';
export const SCAN_N_WIN_RIGHT_ARROW = baseUrl + 'pos/right-arrow.svg';
export const SCAN_N_WIN_CURRENT_WINNER =
  baseUrl + 'pos/scan-n-win-current-winner.svg';
export const SCAN_DISQUALIFED = baseUrl + 'pos/scan-disqualified.svg';
export const SCAN_N_WIN_TNC = baseUrl + 'pos/scan-n-win-tnc.svg';

// table bookings
export const NO_TABLE_BOOKINGS =
  baseUrl + 'table-bookings/no-table-bookings.svg';
export const CALENDAR_ICON = baseUrl + 'table-bookings/calendar.svg';
export const CALENDAR_BLUE_ICON = baseUrl + 'table-bookings/calendar-blue.svg';
export const TABLE_BOOKING_PREVIEW =
  baseUrl + 'table-bookings/table-booking-preview.png';
export const TABLE_BOOKING_NEW_USER =
  baseUrl + 'table-bookings/table-booking-new-user.svg';
export const TABLE_GRID = baseUrl + 'table-bookings/table-grid.svg';
export const PREVIOUS = baseUrl + 'table-bookings/previous.svg';
export const NEXT = baseUrl + 'table-bookings/next.svg';
export const NO_TABLE_BOOKINGS_FILTER =
  baseUrl + 'table-bookings/no-tb-bookings.svg';
export const NO_REJECTED_BOOKINGS =
  baseUrl + 'table-bookings/no-rejected-booking.svg';
export const TABLE_BOOKING_PREVIEW_STEP_1 =
  baseUrl + 'table-bookings/tb-settings-step-1-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_2 =
  baseUrl + 'table-bookings/tb-settings-step-2-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_3 =
  baseUrl + 'table-bookings/tb-settings-step-3-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_4 =
  baseUrl + 'table-bookings/tb-settings-step-4-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_5 =
  baseUrl + 'table-bookings/tb-settings-step-5-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_6 =
  baseUrl + 'table-bookings/tb-settings-step-6-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_7 =
  baseUrl + 'table-bookings/tb-settings-step-7-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_8 =
  baseUrl + 'table-bookings/tb-settings-step-8-preview.webp';
export const TABLE_BOOKING_PREVIEW_STEP_9 =
  baseUrl + 'table-bookings/tb-settings-step-9-preview.webp';
export const TABLE_BOOKING_ICON =
  baseUrl + 'table-bookings/table_booking_icon.svg';
export const TABLE_BOOKING_PENDING_WARN =
  baseUrl + 'table-bookings/table_pending_warn.svg';
export const TABLE_BOOKING_PENDING_CLOSE =
  baseUrl + 'table-bookings/table_pending_close.svg';
export const TABLE_BOOKING_INFO =
  baseUrl + 'table-bookings/info_icon.svg';
export const TABLE_BOOKING_EXPIRING_IN =
  baseUrl + 'table-bookings/expiring_in.svg';
export const LOYALTY_STEP1 = baseUrl + 'loyalty_settings/loyalty-step1.svg';
export const LOYALTY_STEP2 = baseUrl + 'loyalty_settings/loyalty-step2.svg';
export const LOYALTY_STEP2_FC =
  baseUrl + 'loyalty_settings/loyalty-step2-fc.svg';
export const YELLOW_HIGHLIGHT = baseUrl + 'orders/yellow-highlight.svg';

// Collection Infrastructure
export const ORANGE_INFO =
  baseUrl + 'collection-infrastructure/orange-info.svg';
export const ORANGE_INFO_STROKE =
  baseUrl + 'collection-infrastructure/orange-info-stroke.svg';
export const RED_INFO_STROKE =
  baseUrl + 'collection-infrastructure/red-info-stroke.svg';
export const SUBSCRIPTION_CALENDAR_ACTIVE =
  baseUrl + 'collection-infrastructure/subscription-calendar-active.svg';
export const SUBSCRIPTION_CALENDAR_INACTIVE =
  baseUrl + 'collection-infrastructure/subscription-calendar-inactive.svg';
export const SUBSCRIPTION_GRAPHIC_GREEN =
  baseUrl + 'collection-infrastructure/subscription-graphic-green.webp';
export const SUBSCRIPTION_GRAPHIC_YELLOW =
  baseUrl + 'collection-infrastructure/subscription-graphic-yellow.webp';
export const SUBSCRIPTION_GRAPHIC_RED =
  baseUrl + 'collection-infrastructure/subscription-graphic-red.webp';
export const PROMISE_LOCK_IMG =
  baseUrl + 'collection-infrastructure/promise-lock-img.png';
export const EE_LITE = baseUrl + 'collection-infrastructure/ee-lite.svg';
export const EE_PRO = baseUrl + 'collection-infrastructure/ee-pro.svg';
export const LITE_SUB = baseUrl + 'collection-infrastructure/lite.svg';
export const PRO_SUB = baseUrl + 'collection-infrastructure/pro.svg';
export const HQ_REST_DUE_HEADER_IMG =
  baseUrl + 'collection-infrastructure/hq-rest-due-header-img.svg';
export const MODAL_CLOSE =
  baseUrl + 'collection-infrastructure/modal-close.svg';
export const CLOUD_DOWNLOAD =
  baseUrl + 'collection-infrastructure/cloud-download.svg';
export const PAYMENT_OPTIONS =
  baseUrl + 'collection-infrastructure/payment-options.svg';
export const PAYMENT_OPTIONS_ID =
  baseUrl + 'collection-infrastructure/payment-options-id.svg';
export const PAYMENT_CARD =
  baseUrl + 'collection-infrastructure/payment-method-card.svg';
export const PAYMENT_CURLEC =
  baseUrl + 'collection-infrastructure/payment-method-curlec.svg';
export const PAYMENT_SETTLEMENT =
  baseUrl + 'collection-infrastructure/payment-method-settlement.svg';
export const PENDING_BILL_NUDGE =
  baseUrl + 'collection-infrastructure/pending-bill-nudge.svg';
export const PAYMENT_STATUS_SUCCESS =
  baseUrl + 'collection-infrastructure/payment-status-success.webp';
export const PAYMENT_STATUS_FAILED =
  baseUrl + 'collection-infrastructure/payment-status-failed.webp';
export const PAYMENT_STATUS_PENDING =
  baseUrl + 'collection-infrastructure/payment-status-pending.webp';
export const PAYMENT_LOCK =
  baseUrl + 'collection-infrastructure/payment-lock.svg';
export const PROMISE = baseUrl + 'collection-infrastructure/promise.svg';
export const PROMISE_POPUP =
  baseUrl + 'collection-infrastructure/promisepop.svg';
export const LOCKED_IMG = baseUrl + 'collection-infrastructure/locked-img.svg';

// Invoice
export const OLD_INVENTORY_SUPPORT =
  baseUrl + 'invoice/old-inventory-support.webp';
export const PL_EXPENSES = baseUrl + 'invoice/pl-expenses.webp';
export const PL_SUMMARY = baseUrl + 'invoice/pl-summary.webp';
export const NO_INVOICE_DATA = baseUrl + 'invoice/NO_DATA.webp';
export const EOD_SETTING = baseUrl + 'invoice/eod-settings-logo.svg';
export const DOWNLOAD_GREY = baseUrl + 'invoice/download-grey.svg';
export const DOWNLOAD_GREEN = baseUrl + 'invoice/download-green.svg';
export const DOWNLOAD_ORANGE = baseUrl + 'invoice/download-orange.svg';
export const DOWNLOAD_REPORT = baseUrl + 'invoice/download-only.webp';
export const EOD_NO_DATA = baseUrl + 'invoice/eod-no-data.png';

export const RED_LOCK_ICON = baseUrl + 'pos/red-lock-icon.svg';
export const TALK_TO_EXPERT =
  baseUrl + 'collection-infrastructure/talk-to-expert-img.svg ';
export const DOWNLOAD_ICON =
  baseUrl + 'collection-infrastructure/download-icon.svg';

// AI Insights Module images
export const AI_POSTER_IMG = baseUrl + 'ai-insights/ai-poster.webp';
export const AI_TICK_ICON = baseUrl + 'ai-insights/tick.svg';

// Sections & Counters Module
export const CASHIER_SET_UP = baseUrl + 'sections-counters/cashier-setup.webp';
export const CASH_DRAWER_WARNING =
  baseUrl + 'sections-counters/cash-drawer-warning.webp';
export const QR_SCAN_ANIMATION =
  baseUrl + 'sections-counters/qr-scan-animation.mp4';
export const QR_POSTER = baseUrl + 'sections-counters/qr-poster.webp';
export const PRINTER_ACTIVATION_IMG =
  baseUrl + 'sections-counters/printer-icon.svg';
export const DEACTIVATED_PRINTER_IMG =
  baseUrl + 'sections-counters/deactivate-printer-icon.svg';


// FODOCOURT SETTLEMENT
export const DOWNLOAD_ICON_CLOUD = baseUrl +  'common/download-report-icon.svg';
// E-Invoice
export const FAQ_ICON = baseUrl + 'e-invoice/question-icon.svg';
export const INVOICE_ICON = baseUrl + 'e-invoice/e-invoice-icon.svg';
export const E_INVOICE_BACK_ICON = baseUrl + 'e-invoice/back-icon.svg';
export const MY_INVOIS_PORTAL = baseUrl + 'e-invoice/my-invois-portal.png';
export const STEP1 = baseUrl + 'e-invoice/e-invoice-step1.svg';
export const STEP2 = baseUrl + 'e-invoice/e-invoice-step2.svg';
export const STEP3 = baseUrl + 'e-invoice/e-invoice-step3.svg';
export const FIRST_LINE = baseUrl + 'e-invoice/first-line.svg';
export const SECOND_LINE = baseUrl + 'e-invoice/second-line.svg';
export const ARROW_UP_ICON = baseUrl + 'e-invoice/arrow-up.svg';
export const ARROW_DOWN_ICON = baseUrl + 'e-invoice/arrow-down.svg';
export const DOWNLOAD_ACTION_ICON = baseUrl + 'e-invoice/donwload-action-icon.svg';
export const PENDING_ICON = baseUrl + 'e-invoice/pending-icon.svg';
export const SUCCESS_ICON = baseUrl + 'e-invoice/success-icon.svg';
export const EXTERNAL_LINK_ICON = baseUrl + 'e-invoice/redirect-link-icon.svg';
export const E_INVOICE_ARROW_LEFT = baseUrl + 'e-invoice/arrow-left.svg';
export const E_INVOICE_ARROW_RIGHT = baseUrl + 'e-invoice/arrow-right.svg';
export const CROSS_ICON = baseUrl + 'e-invoice/cross-icon.svg';
export const E_INVOICE_TABLE = baseUrl + 'e-invoice/e-invoice-table.png';
export const INTERMEDIARY_PAGE = baseUrl + 'e-invoice/intermediary-page.png';
export const ADD_INTERMEDIARY = baseUrl + 'e-invoice/add-intermediary.png';
export const MY_TAX_HASIL_GOV = baseUrl + 'e-invoice/mytax-hasil-gov.png';
export const SET_INTERMEDIARY_PERMISSION = baseUrl + 'e-invoice/set-intermediary-permission.png';
export const TAX_PAYER_PROFILE = baseUrl + 'e-invoice/tax-payer-profile.png';
export const SET_UP_TIN_CALENDER = baseUrl + 'e-invoice/set-up-tin-calender.png';
export const SETUP_VALIDATE_TIN = baseUrl + 'e-invoice/setup-validate-tin.png';
export const E_INVOICE_HOME_PAGE = baseUrl + 'e-invoice/e-invoice-home-page.png';
export const E_INVOICE_BILL_RECEIPT = baseUrl + 'e-invoice/e-invoice-bill-reciept.png';
export const CUSTOMER_DETAILS = baseUrl + 'e-invoice/customer-details.png';
export const RECEIPT_TO_IRBM = baseUrl + 'e-invoice/reciept-to-irbm.png';
export const VIEW_MANAGE_INVOICE = baseUrl + 'e-invoice/view-manage-invoice.png';
export const E_INVOICE_INFO_ICON = baseUrl + 'e-invoice/e-invoice-info-icon.svg';
export const E_INVOICE_LOADER = baseUrl + 'e-invoice/e-invoice-loader.svg';

// Setup Integration
export const INITIATE_SETUP = baseUrl + 'common/platform-initiate.svg';
export const GREEN_SUCCESS_ICON = baseUrl + 'common/green-success-icon.svg';
export const RED_DESKTOP_ICON = baseUrl + 'common/red-desktop.svg';

//Delivery
export const CALL_ME = baseUrl + 'pos/call_me.svg';
export const COLLAPSE2 = baseUrl + 'pos/collasp2.svg';
export const COPY_LINK = baseUrl + 'pos/copy_link.svg';
export const DONE_STATE = baseUrl + 'pos/done_state.svg';
export const PENDING_STATE = baseUrl + 'pos/pending_state.svg';
export const RIDER_IMAGE = baseUrl + 'pos/rider_image.svg';
export const LICENSE_PLATE = baseUrl + 'pos/lisence.svg';
export const ITEM_PRICE_CONFIRMATION = baseUrl + 'common/item_price_confirmation.svg'
export const ROBOT_FOOD = baseUrl + 'common/robot-food.svg'
export const PRO_MERCHANT_QR_CODE = baseUrl + 'common/cds-pro-merchant.webp'
export const NO_BANNER_FOUND = baseUrl + 'common/no_data_robo.svg';
export const UPLOAD_CLOUD_ICON = baseUrl + 'common/upload_cloud_icon.svg'
